export const educationData = [
    {
        id: 1,
        institution: 'B.Sc. Engg. in Computer Science and Engineering',
        course: ' Khulna University',
        startYear: '2017',
        endYear: '2022'
    },
    {
        id: 2,
        institution: 'Higher Secondary School',
        course: 'Rajshahi Govt. City College, Rajshahi',
        startYear: '2013',
        endYear: '2015'
    },
    {
        id: 3,
        institution: 'Secondary School',
        course: ' Singra Damdama Pilot School and College',
        startYear: '2008',
        endYear: '2013'
    },
]